import { render, staticRenderFns } from "./PeriodConfiguration.vue?vue&type=template&id=4acd5370&scoped=true&"
import script from "./PeriodConfiguration.vue?vue&type=script&lang=js&"
export * from "./PeriodConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PeriodConfiguration.vue?vue&type=style&index=0&id=4acd5370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd5370",
  null
  
)

export default component.exports